<template>
  <div>
    <b-card>
      <b-form-group label-align="right" :label="$t('Is link active')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-checkbox disabled v-model="isActive"/>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Fee recalc start')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input type="text" disabled v-model="feeStart"/>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Fee recalc duration')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input type="text" disabled v-model="feeDuration"/>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Traffic recalc start')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="isAdvanced">
        <b-form-input type="text" disabled v-model="ipTelStart"/>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Traffic recalc duration')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="isAdvanced">
        <b-form-input type="text" disabled v-model="ipTelDuration"/>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Charged')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input type="text" disabled v-model="serviceStats.charged_in_curr_period"/>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Repaid')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input type="text" disabled v-model="serviceStats.repaid_in_curr_period"/>
      </b-form-group>
    </b-card>
    <b-row>
      <b-col>
        <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="hideFormCharged">Ok</b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>

import moment from 'moment'
import axiosInstance from '@/utils/api.js'

export default {
  props: {
    currentService: null
  },
  data () {
    return {
      serviceStats: {},
      isAdvanced: false,
      isActive: true,
      feeStart: '',
      feeDuration: '',
      ipTelStart: '',
      ipTelDuration: ''
    }
  },
  methods: {
    async load () {
      this.serviceStats = await axiosInstance.get(this.$store.getters.API_USERS_SERVICELINKS_PERIODIC_SLINK_STATS + '?slink_id=' + this.currentService.service_link_id).then(response => { return response.data })
      if (this.serviceStats.is_planning) {
        this.isActive = false
      }
      if (!this.serviceStats.fee_recalc.start) {
        this.feeStart = this.$i18n.t('NA')
      } else {
        this.feeStart = moment(Number(this.serviceStats.fee_recalc.start) * 1000).format('YYYY-MM-DD hh:mm')
      }
      this.feeDuration =
      this.serviceStats.fee_recalc.duration / 86400 + this.$i18n.t('d. ') +
      this.serviceStats.fee_recalc.duration / 3600 + this.$i18n.t('h. ') +
      this.serviceStats.fee_recalc.duration / 60 + this.$i18n.t('m.')

      if (this.currentService.service_type === 3) {
        this.isAdvanced = true
        if (!this.serviceStats.ip_recalc.start) {
          this.ipTelStart = this.$i18n.t('NA')
        } else {
          this.ipTelStart = moment(Number(this.serviceStats.ip_recalc.start) * 1000).format('YYYY-MM-DD hh:mm')
        }
        this.ipTelDuration =
        this.serviceStats.ip_recalc.duration / 86400 + this.$i18n.t('d. ') +
        this.serviceStats.ip_recalc.duration / 3600 + this.$i18n.t('h. ') +
        this.serviceStats.ip_recalc.duration / 60 + this.$i18n.t('m.')
      }
      if (this.currentService.service_type === 6) {
        this.isAdvanced = true
        if (!this.serviceStats.tel_recalc.start) {
          this.ipTelStart = this.$i18n.t('NA')
        } else {
          this.ipTelStart = moment(Number(this.serviceStats.tel_recalc.start) * 1000).format('YYYY-MM-DD hh:mm')
        }
        this.ipTelDuration =
        this.serviceStats.tel_recalc.duration / 86400 + this.$i18n.t('d. ') +
        this.serviceStats.tel_recalc.duration / 3600 + this.$i18n.t('h. ') +
        this.serviceStats.tel_recalc.duration / 60 + this.$i18n.t('m.')
      }
    },
    hideFormCharged () {
      this.$emit('hideFormCharged')
    }
  },
  mounted () {
    this.load()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/serviceLinks/formCharged.vue